/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { Map } from 'immutable';

const rememberStoreStatus = (state, action, status) => {
  let newState = state.set(action.storeName, { status, date: Date.now() });
  if (newState.find((value, key) => key !== 'isLoading' &&
    (value.status === undefined || value.status == 'loading'))) {
    if (newState.get('isLoading') !== true) {
      newState = newState.set('isLoading', true);
    }
  } else {
    if (newState.get('isLoading') === true) {
      newState = newState.set('isLoading', false);
    }
  }
  return newState;
};

const resetStoreStatus = (state) => state.clear();

export const storeStatusReducer = (state = Map(), action) => {
  switch (action.type) {
    case 'STORE_LOADING':
      return rememberStoreStatus(state, action, 'loading');
    case 'STORE_LOADED':
      return rememberStoreStatus(state, action, 'loaded');
    case 'STORE_STATUS_RESET':
      return resetStoreStatus(state);
    default:
      return state;
  }
};

export const markStoreLoading = (dispatch, storeName) =>
  dispatch({ type: 'STORE_LOADING', storeName });

export const markStoreLoaded = (dispatch, storeName) =>
  dispatch({ type: 'STORE_LOADED', storeName });

export const clearAllStatuses = (dispatch) =>
  dispatch({ type: 'STORE_STATUS_RESET' });
